import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_NEUTRAL_WHITE } from '../../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_SMALL_TEXT, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02 } from '../../styles/typography/typography';
import { EmbersMenuLaunchButton } from '../../menu/menuLaunchButton';
export var StyledAvatar = styled(EmbersMenuLaunchButton)(function () {
  return {
    '&.EmbersHeader-avatar-root': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      marginRight: 16,
      marginLeft: 24,
      outline: 'none',
      '&:focus-visible': {
        outline: '2px solid ' + PROMETHEAN_NEUTRAL_WHITE
      },
      '.EmbersHeader-avatar-img': {
        width: 28,
        height: 28,
        borderRadius: '50%',
        padding: 0
      },
      '.EmbersHeader-avatar-initials': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT), {}, {
        color: PROMETHEAN_NEUTRAL_WHITE,
        border: "2px solid ".concat(PROMETHEAN_NEUTRAL_WHITE),
        borderRadius: '50%',
        boxSizing: 'border-box',
        width: 28,
        height: 28,
        textAlign: 'center',
        lineHeight: '24px'
      }),
      '.icon-user-alt': {
        color: PROMETHEAN_NEUTRAL_WHITE,
        height: 28,
        width: 28,
        marginRight: 10.5,
        fontSize: 37,
        lineHeight: '28px'
      },
      '.EmbersHeader-avatar-signInText': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
        color: PROMETHEAN_NEUTRAL_WHITE,
        marginRight: 3.5
      })
    },
    '&.EmbersHeader-avatar-notSignedIn': {
      marginRight: 10
    }
  };
});